/**
 * Add a prefix to each key in the object.
 * @param prefix The prefix to add.
 * @param object The object with keys to prefix.
 */
export const prefixObjectKeys = (prefix, object) => {
  return Object.fromEntries(Object.entries(object).map(([key, val]) => [`${prefix}${key}`, val]));
};